export const JOOR_PAY_LINK = 'https://www.joor.com/joor-pay'
export const HAMBURGER_MENU_MAX_WIDTH = 1024
